import { z } from 'zod'
import { oc } from '@orpc/contract'
import { cpgFamilyGroupSchema, cpgFamilySchema } from './cpg-registry.contract'

/**
 * Family registry endpoints. The whole registry is one screenful (35 families in 5 groups),
 * so the list is unpaged and grouped. Groups themselves are seeded/read-only for now
 * (group CRUD is a recorded later item — docs/cpg/RISKS_GAPS_NOTES.md).
 */
export const listCpgFamilies = oc
  .route({ method: 'GET', path: '/v2/cpg/families' })
  .input(z.object({}).optional())
  .output(z.object({ data: z.array(cpgFamilyGroupSchema) }))

export const createCpgFamily = oc
  .route({ method: 'POST', path: '/v2/cpg/families' })
  .input(
    z.object({
      groupId: z.number().int().positive(),
      /** kebab-case, the LLM-facing identity — immutable once created. */
      slug: z
        .string()
        .regex(/^[a-z0-9]+(-[a-z0-9]+)*$/, 'slug must be kebab-case (a-z, 0-9, dashes)'),
      label: z.string().min(1),
      description: z.string().min(1),
    }),
  )
  .output(z.object({ data: cpgFamilySchema }))

/** Partial edit; slug/group are immutable (slug is the classifier's stable identity). */
export const updateCpgFamily = oc
  .route({ method: 'PATCH', path: '/v2/cpg/families/{id}' })
  .input(
    z.object({
      id: z.coerce.number().int().positive(),
      label: z.string().min(1).optional(),
      description: z.string().min(1).optional(),
      active: z.boolean().optional(),
    }),
  )
  .output(z.object({ data: cpgFamilySchema }))
